import React, { useContext } from 'react';
import styles from '../../css/components/footers/standardFooter.css';
import { OneLPSsdkParamsContext } from '../../onelps-sdk-params-context';
import { AppContext } from '../../Store';
import FooterLinkList from './FooterLinkList';
import PropTypes from 'prop-types';
import SocialMediaLinkList from '../common/SocialMediaLinkList';
import InnogamesLogoIcons from '../common/InnogamesLogoIcons';
import { INNOGAMES_LINK } from '../common/links/InnoGamesLink';
import MoreGamesLinkList from './MoreGamesLinkList';
import UskLabelSmall from '../common/UskLabelSmall';

function StandardFooter({
	showLogo = false,
	showMoreGamesLinkList = false,
	hasNestedClass = '',
}) {
	const onelpsParams = useContext(OneLPSsdkParamsContext);
	const [state] = useContext(AppContext);
	const isPreLanderActive = onelpsParams.preLander?.show && !state.preLanderCompleted;
	const showUskLabel = onelpsParams.uskLabel?.show && onelpsParams.uskLabel?.footer === true && onelpsParams.country === 'DE' && !isPreLanderActive;

	if (isPreLanderActive) {
		return null;
	}

	return (

		<footer className={`${styles.footer} ${styles[onelpsParams.gameId]} ${styles[onelpsParams.bigbeat]} ${hasNestedClass ? styles[hasNestedClass] : ''}`}>
			{onelpsParams.socialMedia.show && onelpsParams.socialMedia.position === 'footer' && (
				<SocialMediaLinkList
					facebookLinkId="page_footer_n/a_logo_facebook"
					youtubeLinkId="page_footer_n/a_logo_youtube"
					discordLinkId="page_footer_n/a_logo_discord"
					instagramLinkId="page_footer_n/a_logo_instagram"
				/>
			)}
			{showMoreGamesLinkList && (
				<MoreGamesLinkList />
			)}
			<FooterLinkList />
			{showLogo && (
				<a
					href={INNOGAMES_LINK}
					className={styles.innogamesLogo}
					target="_blank"
					rel="noreferrer"
					id="page_footer_n/a_logo_innogames"
				>
					<InnogamesLogoIcons/>
				</a>
			)}

			{showUskLabel && <UskLabelSmall />}

		</footer>
	);
}

export default StandardFooter;

StandardFooter.propTypes = {
	showLogo: PropTypes.bool,
	showMoreGamesLinkList: PropTypes.bool,
	hasNestedClass: PropTypes.string,
};
